import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import httpService from "../../../../services/httpServices/httpServices";
import typePayment from "../TypePayment";
import Pagination from "../../../partials/content/Pagination";

function ManageAllInvoices() {
  const [payments, setPayments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [paymentIDSearchFilter, setPaymentIDSearchFilter] = useState();

  useEffect(() => {
    getAllPayments();
  }, []);

  useEffect(() => {
    getAllPayments();
  }, [currentPage, countItemPerPage, paymentIDSearchFilter]);

  const getAllPayments = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllInvoices = await sendRequestGetAllPayments(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetAllInvoices) {
      return;
    }

    setCountPage(resultSendRequestGetAllInvoices.count_page);
    setPayments(resultSendRequestGetAllInvoices.payment);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (paymentIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${paymentIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetAllPayments = async (searchFilterQuery) => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      result = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/payment/manage/list/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generatePayments = () => {
    return (
      <>
        <div className="alert alert-info">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره پرداخت</label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setPaymentIDSearchFilter(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره پرداخت</td>
                <td>شماره کاربر</td>
                <td>نام کاربر</td>
                <td>مبلغ(تومان)</td>
                <td>کد پیگیری</td>
                <td>کد پیگیری زرین پال</td>
                <td>حالت</td>
                <td>فاکتور رسمی</td>
                <td>تاریخ درج</td>
                <td>تاریخ بروزرسانی</td>
                <td>تاریخ پرداخت</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, index) => {
                return (
                  <tr>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>{helpersNumbers.toPersianNum(payment.pay_id)}</td>
                    <td>{helpersNumbers.toPersianNum(payment.pay_user_id)}</td>
                    <td>{helpersNumbers.toPersianNum(payment.user_name)}</td>
                    <td>
                      <span className="letter-spacing-finance-number">
                        {helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(
                            payment.pay_amount
                          )
                        )}
                      </span>
                    </td>
                    <td>{payment.pay_ref}</td>
                    <td>{payment.pay_res}</td>
                    <td>{generateStatusTagPayment(payment.pay_status)}</td>
                    <td>
                      {payment.pay_send_invoice ? (
                        <span className="badge badge-success">صادر شده</span>
                      ) : (
                        <span className="badge badge-danger">صادر نشده</span>
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(payment.pay_created_at)}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(payment.pay_updated_at)}
                    </td>
                    <td>{helpersNumbers.toPersianNum(payment.pay_paid_at)}</td>
                    <td>
                      {payment.pay_status == typePayment.statusPayment.PAID && (
                        <Link to={`/finance/manage/invoice/${payment.pay_id}`}>
                          <span className="btn btn-info">
                            <i className="fa fa-eye"></i>
                          </span>
                        </Link>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const generateStatusTagPayment = (paymentStatus) => {
    let statusTagPayment = <></>;
    switch (paymentStatus) {
      case typePayment.statusPayment.PAID:
        statusTagPayment = (
          <span className="badge badge-success">
            {typePayment.typeStatusString()[paymentStatus]}
          </span>
        );
        break;
      case typePayment.statusPayment.PENDING:
        statusTagPayment = (
          <span className="badge badge-warning">
            {typePayment.typeStatusString()[paymentStatus]}
          </span>
        );
        break;
      case typePayment.statusPayment.FAILED:
        statusTagPayment = (
          <span className="badge badge-danger">
            {typePayment.typeStatusString()[paymentStatus]}
          </span>
        );
        break;
    }
    return statusTagPayment;
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="all-payments" />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">لیست پرداخت ها</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              {payments.length == 0 && paymentIDSearchFilter == null ? (
                <></>
              ) : (
                generatePayments()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default ManageAllInvoices;
